import { UserFollowedLeader, YammerState } from '../../state/types';
import { createFindById, createFindByIdThrows } from '../findById';

export const findById = createFindById<UserFollowedLeader>('userFollowedLeaders');
export const findByIdThrows = createFindByIdThrows<UserFollowedLeader>('userFollowedLeaders');

type GetFulfilledUserFollowedLeaders = (state: YammerState) => Record<string, UserFollowedLeader>;
export const getFulfilledUserFollowedLeaders: GetFulfilledUserFollowedLeaders = (state) =>
  state.userFollowedLeaders.fulfilled.byId;
